import Cross from 'assets/svg/cancel-login/cancel.svg'
import Button from 'common/components/Button'
import Flex from 'common/components/Flex'
import Modal from 'common/components/Modal'
import Typography from 'common/components/Typography'
import theme from 'common/theme'
import { ReactNode } from 'react'
import styled from 'styled-components'

const CrossIcon = styled(Cross)`
  position: absolute;
  right: 30px;
  top: 30px;
  cursor: pointer;
`

const StyledFlex = styled(Flex)`
  gap: ${({ gap }) => gap};
  width: 100%;
`

const TypographyButton = styled(Typography)`
  cursor: pointer;
  :hover {
    filter: brightness(1.1);
  }
`

interface IConfirmationModalProps {
  title: string
  description: string | JSX.Element
  icon?: ReactNode
  primaryButtonText: string
  secondaryButtonText?: string
  onClickPrimary: Function
  onClickSecondary?: Function
  onClose?: () => void
  isOpen: boolean
  width?: string
  height?: string
  padding?: string
  ctaDirection?: 'column' | 'row'
  bottomAnchorText?: string
  onClickBottomAnchor?: Function
  disabledPrimary?: boolean
  additionalStyle?: string
  loadingPrimary?: boolean
  hiddenSecondary?: boolean
}

function ConfirmationModal({
  title,
  description,
  icon,
  primaryButtonText,
  secondaryButtonText,
  onClickPrimary,
  onClickSecondary,
  onClose,
  isOpen,
  width = '560px',
  height = 'auto',
  padding = '32px',
  ctaDirection = 'row',
  bottomAnchorText,
  onClickBottomAnchor,
  disabledPrimary,
  additionalStyle,
  loadingPrimary,
  hiddenSecondary,
}: IConfirmationModalProps): JSX.Element {
  return (
    <Modal
      isOpen={isOpen}
      onOverlayClick={onClose}
      width={width}
      height={height}
      padding={padding}
      borderRadius={theme.radius.lg}
      additionalStyle={additionalStyle}
    >
      {onClose && (
        <CrossIcon
          data-testid="confirmation-modal-close"
          onClick={onClose}
        />
      )}
      <StyledFlex
        gap="24px"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <>{icon}</>
        <Typography type="bh2" textAlign="center">
          {title}
        </Typography>
        {typeof description === 'string' ? (
          <Typography type="rparagraph" textAlign="center">
            {description}
          </Typography>
        ) : (
          description
        )}
        <StyledFlex
          flexDirection={ctaDirection}
          gap="16px"
          margin="4px 0 0 0"
        >
          {secondaryButtonText && !hiddenSecondary && (
            <Button
              data-testid="btn-secondary-modal"
              variant="outlined"
              color="redOrange"
              onClick={onClickSecondary}
              fontWeight="bold"
              fontSize="16px"
              size="large"
              block
              borderRadius={theme.radius.lg}
            >
              {secondaryButtonText}
            </Button>
          )}
          <Button
            data-testid="btn-primary-modal"
            color="redOrange"
            size="large"
            onClick={onClickPrimary}
            fontSize="16px"
            fontWeight="bold"
            block
            borderRadius={theme.radius.lg}
            disabled={disabledPrimary}
            isLoading={loadingPrimary}
          >
            {primaryButtonText}
          </Button>
        </StyledFlex>
        {bottomAnchorText && (
          <TypographyButton
            data-testid="bottom-anchor-btn"
            type="bsubtitle"
            color="redOrange"
            onClick={onClickBottomAnchor}
            textAlign="center"
          >
            {bottomAnchorText}
          </TypographyButton>
        )}
      </StyledFlex>
    </Modal>
  )
}

export default ConfirmationModal
